module.exports = __webpack_public_path__ + "assets/futurafuturisc-bold-webfont.ca9bea9ebe2e083bc33fb4d013a516f3a32574a2b4111ac10ee4c5974a043bb0.woff";